import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { PaymentProvider } from '@as-react/common-types';
import { useAemConfig } from '@as-react/common-components';
import { PaymentRequestGroupGeneric } from '../../../components/checkout/payment-request/PaymentRequestGroupGeneric';
import { checkoutMutations } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
export const PaymentRequestGroupGenericContainer = ({ paymentRequestId, selectedPaymentOption, group, }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const { postPaymentRequest, postPaymentProviderInputRequest } = checkoutMutations({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { mutateAsync: postPaymentRequestMutation } = useMutation(postPaymentRequest);
    const { mutateAsync: postPaymentProviderInputRequestMutation } = useMutation(postPaymentProviderInputRequest);
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        const paymentData = {
            chosenPaymentOption: selectedPaymentOption === null || selectedPaymentOption === void 0 ? void 0 : selectedPaymentOption.name,
            chosenPaymentOptionId: selectedPaymentOption === null || selectedPaymentOption === void 0 ? void 0 : selectedPaymentOption.id,
            tp: `${defaultRequestParams.mainWebshop}.html`,
        };
        const providerInformation = yield postPaymentRequestMutation({ paymentRequestId, payment: paymentData });
        if (providerInformation.provider === PaymentProvider.SAFERPAY) {
            const result = yield postPaymentProviderInputRequestMutation({
                provider: providerInformation.provider,
                data: {
                    fictiveWebshopId: defaultRequestParams.shopId,
                    market: defaultRequestParams.market,
                    paymentRequestId: paymentRequestId,
                },
            });
            if (result === null || result === void 0 ? void 0 : result.redirectUrl) {
                location.href = result.redirectUrl;
            }
        }
    });
    return _jsx(PaymentRequestGroupGeneric, { selected: true, group: group, onSubmit: handleSubmit });
};
